import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import StarSvg from '../../../../public/static/icons/star.svg';
import LightBulbSvg from '../../../../public/static/icons/lightingbulb.svg';

export const StyledSuggestionBoxWrapper = styled.div`
    color: ${(props) => props.theme.shades.blackGrey};
    border: 1px solid rgba(151, 151, 151, 0.5);
    height: 100%;
`;

export const StyledHeadlineBox = styled.div`
    background-color: ${(props: { background: string }) => props.background};
    display: flex;
`;

export const StyledIconBox = styled.div<{ background: string; type: string }>`
    background-color: ${(props) => props.background};
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 40px;
    flex-basis: ${(props) => (props.type === 'exclusive' ? '40px' : '60px')};
    flex-grow: 0;
    flex-shrink: 0;
    position: relative;

    /* triangle on the suggestion icon box */
    ${(props) =>
        props.type === 'suggestion'
            ? css`
                  svg {
                      margin-left: -10px;
                  }

                  &:after {
                      content: '';
                      border-style: solid;
                      border-width: 20px 10px 20px 0px;
                      border-color: transparent ${props.theme.colors['main2-20']} transparent
                          transparent;
                      position: absolute;
                      right: -1px;
                      top: 0px;
                  }
              `
            : null}
`;

export const StyledHeadline = styled.h4`
    font-size: ${(props) => props.theme.fontSize.copyTextL};
    font-weight: 700;
    margin: 0;
    padding: 0;
    flex-grow: 1;
    text-align: center;
    align-self: center;
`;

export const StyledTextBox = styled.div`
    text-align: center;
    padding: 15px;

    p {
        font-size: ${(props) => props.theme.fontSize.copyTextM};
    }
`;

export const StyledStarSvg = styled(StarSvg)`
    height: 21px;
    width: 21px;
    fill: ${(props) => props.theme.shades.white};
`;

export const StyledLightBulbSvg = styled(LightBulbSvg)`
    height: 21px;
    width: 21px;
    fill: ${(props) => props.theme.shades.white};
`;
